module.exports = __webpack_public_path__ + "img/full_scan.86c70d71.png";